// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("./node_modules/url-search-params-polyfill/index.js");
var __webpack_exports__ = __webpack_require__("./src/index.jsx");
